// components/EventSchedule.tsx
import React from "react";

import cupIllustration from "../../assets/cup-illustration.png";
import plateIllustration from "../../assets/plate-illustration.png";
import girlDrinking from "../../assets/girl-drinking.png";
import scheduleImg from "../../assets/scheduleImg.jpg";
import welcomeReception from "../../assets/welcomeReception.jpg";
import openKitchen from "../../assets/openKitchen.jpg";

export default function EventSchedule() {
  const events = [
    {
      time: "6:00 pm — 7:00 pm",
      speaker: "Welcome Reception",
      topic: "Arrival, welcome drinks & optional photo moment",
      description:
        "Settle in with a welcome drink. Mark the moment with an optional black-tie photographer experience before we begin",
      image: welcomeReception,
    },
    {
      time: "7:00 pm — 9:30 pm",
      speaker: "Open Kitchen · Five-Course Private Dining",
      topic: "Led by Chef Tandoh",
      description:
        "From the open pass, five courses are served at a measured pace with brief notes from the chef. Between courses, expect a short word from our founder/partners and a light, optional interaction to help the room connect!",
      image: openKitchen,
    },
    {
      time: "9:30 pm — Late",
      speaker: "After-Dinner Lounge & Conversations",
      topic: "A measured close",
      description:
        "Drift into the lounge for ambient music with room for a drink and easy conversation, a relaxed close to the night.",
      image: scheduleImg,
    },
  ];

  return (
    <section
      className="relative bg-white overflow-hidden pt-20"
      data-aos="fade-up"
    >
      {/* Background Illustrations */}
      <img
        src={cupIllustration}
        alt="Cup Illustration"
        className="absolute top-0 right-0 w-28 md:w-48 opacity-90"
        data-aos="fade-down-left"
        data-aos-delay="300"
      />
      <img
        src={girlDrinking}
        alt="Cup Illustration"
        className="hidden lg:block absolute bottom-80 md:bottom-40 right-0 w-28 md:w-40 opacity-90"
        data-aos="fade-left"
        data-aos-delay="400"
      />
      <div
        className="absolute bottom-8 left-6 lg:bottom-20 lg:left-0 w-24 h-24 lg:w-60 lg:h-60 z-0"
        data-aos="fade-up-right"
        data-aos-delay="500"
      >
        <img
          src={plateIllustration}
          alt="Plate illustration"
          className="w-auto h-auto opacity-80"
        />
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Header Section */}
        <div
          className="text-center mb-16"
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <p className="text-xs lg:text-sm tracking-widest text-[#4E5C36] uppercase mb-4">
            Event Schedule
          </p>
          <div
            className="mt-6 inline-block bg-[#4E5C36] text-white px-6 py-3 rounded-md shadow text-sm md:text-base"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            <span className="favela text-2xl font-bold">Event Day</span>
            <span className="block">Saturday, 06 December, 2025</span>
          </div>
        </div>

        {/* Events List laptop and tab view */}
        <div className="space-y-12 hidden md:block">
          {events.map((event, index) => (
            <div
              key={index}
              className="grid grid-cols-[220px_minmax(0,1fr)] items-start gap-8 border-b border-dashed border-gray-300 pb-10"
              data-aos="fade-up"
              data-aos-delay={200 * (index + 1)}
            >
              {/* Event Image */}
              <div className="flex-shrink-0">
                <img
                  src={event.image}
                  alt={event.topic}
                  className="w-full h-32 lg:h-40 object-cover rounded-md shadow"
                />
              </div>

              {/* Event Info */}
              <div className="flex flex-col justify-between h-full">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4">
                  {/* Left Column: Time */}
                  {/* <div className="w-full md:w-48 flex-shrink-0">
                    <p className="text-sm text-gray-700 font-medium whitespace-nowrap">
                      {event.time}
                    </p>
                  </div> */}

                  {/* Right Column: Content */}
                  <div className="flex-1">
                    <h4 className="text-gray-900 font-semibold">
                      {event.speaker}
                    </h4>
                    <p className="text-lg text-[#4E5C36] font-medium mb-2">
                      {event.topic}
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed max-w-3xl">
                      {event.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Events List mobile view */}
        <div className="space-y-10 block md:hidden">
          {events.map((event, index) => (
            <div
              key={index}
              className="grid grid-cols-[100px_1fr] sm:grid-cols-[150px_1fr] items-start gap-4 sm:gap-6 border-b border-dashed border-gray-300 pb-10"
              data-aos="fade-up"
              data-aos-delay={200 * (index + 1)}
            >
              <div>
                <img
                  src={event.image}
                  alt={event.topic}
                  className="w-full h-24 sm:h-28 object-cover rounded-md shadow"
                />
              </div>
              <div className="flex flex-col gap-3">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  {/* <div className="text-xs sm:text-sm text-gray-700 font-medium">
                    {event.time}
                  </div> */}
                  <div>
                    <h4 className="text-gray-900 font-semibold">
                      {event.speaker}
                    </h4>
                    <p className="text-base sm:text-lg text-[#4E5C36] font-medium">
                      {event.topic}
                    </p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
